import React from 'react'
import cx from 'classnames'

import Image from '@/image.js'

class AboutHero extends React.Component {
  constructor() {
    super()
    this.state = {
      visible: false
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        visible: true
      })
    }, 1000)
  }
  render () {
    const {
      headerImages,
      titleOne,
      titleTwo,
      description
    } = this.props
    return (
      <div className={cx('about__hero f jcb ais fw', {
        'is-animated': this.state.visible
      })}>
        <div className='p15 mt0 mb15 about__hero-mobile x'>
          <h1 className='m0 h1 p0' dangerouslySetInnerHTML={{ __html: titleOne.replace(/[\r\n]+/g, '<br />') }} />
        </div>
        <div className='x'>
          <Image className='animate a-o a-t' imageId={headerImages[0].imageId} alt={titleOne} />
          <div className='p15 animate a-o a-t a-d-6'>
            <h2 className='h1 mt05 mb0'>{titleTwo}</h2>
            <p className='s22'>{description}</p>
          </div>
        </div>
        <div className='container--xl mxa x p15 about__hero-right'>
          <div>
            <h2 className='m0 h1 p0 mb1 animate a-o a-t a-d-4' dangerouslySetInnerHTML={{ __html: titleOne.replace(/[\r\n]+/g, '<br />') }} />
            {headerImages.length > 1 && (<Image className='animate a-o a-t' imageId={headerImages[1].imageId} />)}
          </div>
        </div>
      </div>
    )
  }
}

export default AboutHero